import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import RunsheetIcon from "../../Icons/RunsheetIcon";
const AttendanceReportListComponent = loadable(
  () => import("../../components/AttendanceReport/AttendanceReportList")
);
const AttendanceReportList = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        < RunsheetIcon/>
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Attendance Report
        </span>
      </div>
      <AttendanceReportListComponent 
      />
    </>
  );
};

export default AttendanceReportList;
